import {
  AUTH_LOGIN,
  AUTH_LOGOUT, CHANGE_USER_WORK_STATUS,
  CREATE_USER, DISABLE_2FA,
  EDIT_BALANCE, EDIT_SUPPORT_LIMIT,
  EDIT_USER, ENABLE_2FA, GET_2FA_DATA, LOAD_BALANCE, LOAD_USERS_PROJECTS,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT, LOAD_PROJECTS
} from './user';
import {
  ADD_ORDER,
  BUMP_ORDER, CANCEL_ORDER,
  CONFIRM_ORDER,
  LOAD_ORDERS_LIST, LOAD_STATS,
  RESTART_ORDER
} from '@/store/const/orders';
import { ADD_WHITELIST_WALLET, DELETE_WHITELIST_WALLET, LOAD_SETTINGS, UPDATE_SETTING } from "@/store/const/settings";
import { CREATE_ACCOUNT, DELETE_ACCOUNT, LOAD_ACCOUNTS_LIST, LOAD_ACCOUNTS_NAMES } from '@/store/const/accounts';


const path = {
  [AUTH_LOGIN]: 'users/login',
  [AUTH_LOGOUT]: 'users/logout',
  [LOAD_USERS_LIST]: 'users',
  [CREATE_USER]: 'users',
  [EDIT_USER]: 'users/:name:',
  [EDIT_BALANCE]: 'users/:name:/balance',
  [EDIT_SUPPORT_LIMIT]: 'users/:id:/limit/edit',
  [RESET_SUPPORT_LIMIT]: 'users/:id:/limit/reset',
  [CHANGE_USER_WORK_STATUS]: 'users/settings/work_status/:status:',
  [GET_2FA_DATA]: 'users/2fa/data',
  [ENABLE_2FA]: 'users/2fa/enable',
  [DISABLE_2FA]: 'users/2fa/disable',
  [LOAD_BALANCE]: 'users/balance',
  [LOAD_ORDERS_LIST]: 'orders',
  [ADD_ORDER]: 'orders',
  [CONFIRM_ORDER]: 'orders/confirm/:id:',
  [RESTART_ORDER]: 'orders/restart/:id:',
  [BUMP_ORDER]: 'orders/bump/:id:',
  [CANCEL_ORDER]: 'orders/cancel/:id:',
  [LOAD_SETTINGS]: 'settings/global',
  [UPDATE_SETTING]: 'settings/global',
  [ADD_WHITELIST_WALLET]: 'settings/whitelist',
  [DELETE_WHITELIST_WALLET]: 'settings/whitelist',
  [CREATE_ACCOUNT]: 'accounts',
  [LOAD_ACCOUNTS_LIST]: 'accounts',
  [LOAD_ACCOUNTS_NAMES]: 'accounts/names',
  [DELETE_ACCOUNT]: 'accounts/:id:',
  [LOAD_PROJECTS]: 'users/projects',
  [LOAD_USERS_PROJECTS]: 'users/projects/list',
  [LOAD_STATS]: 'stats',
};
export default path;
